import { render } from "./RfTarjeta.vue?vue&type=template&id=3cbb858a"
import script from "./RfTarjeta.vue?vue&type=script&lang=js"
export * from "./RfTarjeta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__